if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;
        var this2 = this;
        this.handleErrorMessage();

        if (
          $(this).parents(".custom_card_recommendation").length != 0 ||
          $(this).parents(".custom_main_complementary_card_product").length != 0
        ) {
          $(this)
            .parents(".custom_card_recommendation")
            .find(".select-error")
            .remove();
          if ($(this).parents(".custom_card_recommendation").length != 0) {
            if (
              $(this)
                .parents(".custom_card_recommendation")
                .find(".variants-pills.selected").length == 0
            ) {
              $(this)
                .parents(".custom_card_recommendation")
                .find(".cart_custom_product_variant_container")
                .after(`<div class="select-error select-error-size caption_2" style="color:#8E6A3D; ">
                      <svg
                        aria-hidden="true"
                        focusable="false"
                        class="icon icon-error"
                        viewBox="0 0 13 13"
                      >
                        <circle cx="6.5" cy="6.50049" r="5.5" stroke="white" stroke-width="2"/>
                        <circle cx="6.5" cy="6.5" r="5.5" fill="#8E6A3D" stroke="#8E6A3D" stroke-width="0.7"/>
                        <path d="M5.87413 3.52832L5.97439 7.57216H7.02713L7.12739 3.52832H5.87413ZM6.50076 9.66091C6.88091 9.66091 7.18169 9.37267 7.18169 9.00504C7.18169 8.63742 6.88091 8.34917 6.50076 8.34917C6.12061 8.34917 5.81982 8.63742 5.81982 9.00504C5.81982 9.37267 6.12061 9.66091 6.50076 9.66091Z" fill="white"/>
                        <path d="M5.87413 3.17832H5.51535L5.52424 3.537L5.6245 7.58083L5.63296 7.92216H5.97439H7.02713H7.36856L7.37702 7.58083L7.47728 3.537L7.48617 3.17832H7.12739H5.87413ZM6.50076 10.0109C7.06121 10.0109 7.5317 9.57872 7.5317 9.00504C7.5317 8.43137 7.06121 7.99918 6.50076 7.99918C5.94031 7.99918 5.46982 8.43137 5.46982 9.00504C5.46982 9.57872 5.94031 10.0109 6.50076 10.0109Z" fill="white" stroke="#8E6A3D" stroke-width="0.7">
                      </svg>
                      <span class="errormsg detail_8 mobile_body_8">Please select color.</span>
                    </div>`);
              if ($("body").data("template") == "cart") {
                $(this)
                  .parents(".custom_card_recommendation")
                  .find(".custom_product_variant_container")
                  .after(`<div class="select-error select-error-size caption_2" style="color:#8E6A3D; ">
                      <svg
                        aria-hidden="true"
                        focusable="false"
                        class="icon icon-error"
                        viewBox="0 0 13 13"
                      >
                        <circle cx="6.5" cy="6.50049" r="5.5" stroke="white" stroke-width="2"/>
                        <circle cx="6.5" cy="6.5" r="5.5" fill="#8E6A3D" stroke="#8E6A3D" stroke-width="0.7"/>
                        <path d="M5.87413 3.52832L5.97439 7.57216H7.02713L7.12739 3.52832H5.87413ZM6.50076 9.66091C6.88091 9.66091 7.18169 9.37267 7.18169 9.00504C7.18169 8.63742 6.88091 8.34917 6.50076 8.34917C6.12061 8.34917 5.81982 8.63742 5.81982 9.00504C5.81982 9.37267 6.12061 9.66091 6.50076 9.66091Z" fill="white"/>
                        <path d="M5.87413 3.17832H5.51535L5.52424 3.537L5.6245 7.58083L5.63296 7.92216H5.97439H7.02713H7.36856L7.37702 7.58083L7.47728 3.537L7.48617 3.17832H7.12739H5.87413ZM6.50076 10.0109C7.06121 10.0109 7.5317 9.57872 7.5317 9.00504C7.5317 8.43137 7.06121 7.99918 6.50076 7.99918C5.94031 7.99918 5.46982 8.43137 5.46982 9.00504C5.46982 9.57872 5.94031 10.0109 6.50076 10.0109Z" fill="white" stroke="#8E6A3D" stroke-width="0.7">
                      </svg>
                      <span class="errormsg detail_8 mobile_body_8">Please select color.</span>
                    </div>`);
              }
              return;
            }
          }
          if (
            $(this).parents(".custom_main_complementary_card_product").length !=
            0
          ) {
            $(this)
              .parents(".custom_main_complementary_card_product")
              .find(".select-error")
              .remove();
            if (
              $(this)
                .parents(".custom_main_complementary_card_product")
                .find(".variants-pills.selected").length == 0
            ) {
              $(this)
                .parents(".custom_main_complementary_card_product")
                .find(".custom_product_variant_container")
                .append(`<div class="select-error select-error-size caption_2" style="color:#8E6A3D; ">
                      <svg
                        aria-hidden="true"
                        focusable="false"
                        class="icon icon-error"
                        viewBox="0 0 13 13"
                      >
                        <circle cx="6.5" cy="6.50049" r="5.5" stroke="white" stroke-width="2"/>
                        <circle cx="6.5" cy="6.5" r="5.5" fill="#8E6A3D" stroke="#8E6A3D" stroke-width="0.7"/>
                        <path d="M5.87413 3.52832L5.97439 7.57216H7.02713L7.12739 3.52832H5.87413ZM6.50076 9.66091C6.88091 9.66091 7.18169 9.37267 7.18169 9.00504C7.18169 8.63742 6.88091 8.34917 6.50076 8.34917C6.12061 8.34917 5.81982 8.63742 5.81982 9.00504C5.81982 9.37267 6.12061 9.66091 6.50076 9.66091Z" fill="white"/>
                        <path d="M5.87413 3.17832H5.51535L5.52424 3.537L5.6245 7.58083L5.63296 7.92216H5.97439H7.02713H7.36856L7.37702 7.58083L7.47728 3.537L7.48617 3.17832H7.12739H5.87413ZM6.50076 10.0109C7.06121 10.0109 7.5317 9.57872 7.5317 9.00504C7.5317 8.43137 7.06121 7.99918 6.50076 7.99918C5.94031 7.99918 5.46982 8.43137 5.46982 9.00504C5.46982 9.57872 5.94031 10.0109 6.50076 10.0109Z" fill="white" stroke="#8E6A3D" stroke-width="0.7">
                      </svg>
                      <span class="errormsg detail_8 mobile_body_8">Please select color.</span>
                    </div>`);
              console.log("errre");

              return;
            }
          }
        }

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        $(this).find(".productadding").css({ opacity: "0" });
        this.querySelector(".loading-overlay__spinner").classList.remove(
          "hidden"
        );
        $(this).find(".plusbtnsvg").addClass("hidden");

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            var discounttype = $(
              ".discount-wrapper-shop .discount-type"
            ).html();
            if (discounttype == "product") {
              var step = $(".discount-wrapper-shop").data("step");
              var pid1 = $(".discount-wrapper-shop .step-1-product").data('pid');
                var pid2 = $(".discount-wrapper-shop .step-2-product").data('pid');
                var pid3 = $(".discount-wrapper-shop .step-3-product").data('pid');
              var hasvariant1 = $(".discount-wrapper-shop .step-1-hasvariant").html();
                var hasvariant2 = $(".discount-wrapper-shop .step-2-hasvariant").html();
                var hasvariant3 = $(".discount-wrapper-shop .step-3-hasvariant").html();
              var threshhold1 =
                Number($(".discount-wrapper-shop .step-1-threshhold").html()) *
                100;
              var threshhold2 =
                Number($(".discount-wrapper-shop .step-2-threshhold").html()) *
                100;
              var threshhold3 =
                Number($(".discount-wrapper-shop .step-3-threshhold").html()) *
                100;
              var addproduct = false;
              var addvarid = pid1;
              console.log(threshhold1 + " gfg");
              console.log(threshhold2 + " gfg");
              console.log(threshhold3 + " gfg");

              fetch("/cart.js")
                .then((resp) => resp.json())
                .then((resp) => {
                  var found = false;
                  var varid = "";
                  var removeids = [];
                  if (step == "step1") {
                    if (resp.total_price >= threshhold1) {
                      var found = false;
                      for (var i = 0; i < resp.items.length; i++) {
                        if (
                          resp.items[i].variant_id == pid1 &&
                          resp.items[i].properties.hasOwnProperty(
                            "_freeproduct"
                          ) == true
                        ) {
                          found = true;
                        } else {
                          if (
                            resp.items[i].properties.hasOwnProperty(
                              "_freeproduct"
                            )
                          ) {
                            removeids.push(resp.items[i].variant_id);
                          }
                        }
                      }
                      if (found == false && hasvariant1 == 'true') {
                        addproduct = true;
                        addvarid = pid1;
                      }
                    }
                  }
                  if (step == "step2") {
                    if (
                      resp.total_price >= threshhold1 &&
                      resp.total_price < threshhold2
                    ) {
                      var found = false;
                      for (var i = 0; i < resp.items.length; i++) {
                        if (
                          resp.items[i].variant_id == pid1 &&
                          resp.items[i].properties.hasOwnProperty(
                            "_freeproduct"
                          ) == true
                        ) {
                          found = true;
                        } else {
                          if (
                            resp.items[i].properties.hasOwnProperty(
                              "_freeproduct"
                            )
                          ) {
                            removeids.push(resp.items[i].variant_id);
                          }
                        }
                      }
                      if (found == false && hasvariant1 == 'true') {
                        addproduct = true;
                        addvarid = pid1;
                      }
                    } else if (
                      resp.total_price >= threshhold2 &&
                      resp.items[i].properties.hasOwnProperty("_freeproduct") ==
                        true
                    ) {
                      var found = false;
                      for (var i = 0; i < resp.items.length; i++) {
                        if (resp.items[i].variant_id == pid2) {
                          found = true;
                        } else {
                          if (
                            resp.items[i].properties.hasOwnProperty(
                              "_freeproduct"
                            )
                          ) {
                            removeids.push(resp.items[i].variant_id);
                          }
                        }
                      }
                      if (found == false && hasvariant2 == 'true') {
                        addproduct = true;
                        addvarid = pid2;
                      }
                    }
                  }
                  if (step == "step3") {
                    if (
                      resp.total_price >= threshhold1 &&
                      resp.total_price < threshhold2
                    ) {
                      console.log("test");
                      var found = false;
                      for (var i = 0; i < resp.items.length; i++) {
                        if (
                          resp.items[i].variant_id == pid1 &&
                          resp.items[i].properties.hasOwnProperty(
                            "_freeproduct"
                          ) == true
                        ) {
                          found = true;
                        } else {
                          if (
                            resp.items[i].properties.hasOwnProperty(
                              "_freeproduct"
                            )
                          ) {
                            removeids.push(resp.items[i].variant_id);
                          }
                        }
                      }
                      if (found == false && hasvariant1 == 'true') {
                        addproduct = true;
                        addvarid = pid1;
                      }
                    } else if (
                      resp.total_price >= threshhold2 &&
                      resp.total_price < threshhold3
                    ) {
                      var found = false;
                      for (var i = 0; i < resp.items.length; i++) {
                        if (
                          resp.items[i].variant_id == pid2 &&
                          resp.items[i].properties.hasOwnProperty(
                            "_freeproduct"
                          ) == true
                        ) {
                          found = true;
                        } else {
                          if (
                            resp.items[i].properties.hasOwnProperty(
                              "_freeproduct"
                            )
                          ) {
                            removeids.push(resp.items[i].variant_id);
                          }
                        }
                      }
                      if (found == false && hasvariant2 == 'true') {
                        addproduct = true;
                        addvarid = pid2;
                      }
                    } else if (resp.total_price >= threshhold3) {
                      var found = false;
                      for (var i = 0; i < resp.items.length; i++) {
                        if (
                          resp.items[i].variant_id == pid3 &&
                          resp.items[i].properties.hasOwnProperty(
                            "_freeproduct"
                          ) == true
                        ) {
                          found = true;
                        } else {
                          if (
                            resp.items[i].properties.hasOwnProperty(
                              "_freeproduct"
                            )
                          ) {
                            removeids.push(resp.items[i].variant_id);
                          }
                        }
                        if (found == false && hasvariant3 == 'true') {
                          addproduct = true;
                          addvarid = pid3;
                        }
                      }
                    }
                  }
                  if (resp.total_price < threshhold1) {
                    var found = false;
                    for (var i = 0; i < resp.items.length; i++) {
                      if (
                        resp.items[i].properties.hasOwnProperty("_freeproduct")
                      ) {
                        removeids.push(resp.items[i].variant_id);
                        addproduct = true;
                      }
                    }
                  }
                  console.log("addproduct = " + addproduct);

                  if (addproduct == true) {
                    if (removeids.length > 0) {
                      var updates = {};
                      for (let index = 0; index < removeids.length; index++) {
                        updates[removeids[index]] = 0;
                      }

                      const bodyup = JSON.stringify({
                        updates: updates,
                        sections: this.getSectionsToRender().map(
                          (section) => section.section
                        ),
                        sections_url: window.location.pathname,
                      });

                      var this3 = this;

                      fetch(`/cart/update.js`, {
                        method: "POST",
                        headers: {
                          "Content-Type": "application/json",
                        },
                        body: bodyup,
                      })
                        .then((response) => {
                          return response.text();
                        })
                        .then((state) => {
                          addnewproduct();
                        })
                        .catch(() => {
                          addnewproduct();
                        })
                        .finally(() => {});
                    } else {
                      addnewproduct();
                    }
                  } else {
                    if (removeids.length > 0) {
                      var updates = {};
                      for (let index = 0; index < removeids.length; index++) {
                        updates[removeids[index]] = 0;
                      }

                      const bodyup = JSON.stringify({
                        updates: updates,
                        sections: this2.getSectionsToRender().map(
                          (section) => section.section
                        ),
                        sections_url: window.location.pathname,
                      });

                      var this3 = this;

                      fetch(`/cart/update.js`, {
                        method: "POST",
                        headers: {
                          "Content-Type": "application/json",
                        },
                        body: bodyup,
                      })
                        .then((response) => {
                          return response.text();
                        })
                        .then((state) => {
                          addnewproduct();
                        })
                        .catch(() => {
                          addnewproduct();
                        })
                        .finally(() => {});
                    } else {
                      if (resp.total_price == 0) {
                        const body = JSON.stringify({
                          sections: this2.cart.getSectionsToRender().map((section) => section.id),
                          sections_url: window.location.pathname,
                        });

                        fetch(`/cart/clear.js`, {
                          ...fetchConfig(),
                          ...{ body },
                        })
                          .then((response) => {
                            return response.text();
                          })
                          .then((state) => {
                            loadData(state);
                          })
                          .catch(() => {});
                      } else {
                        loadData(response);
                      }
                    }
                  }
                  function addnewproduct() {
                    var variantId = Number(addvarid);

                    const body = JSON.stringify({
                      id: variantId,
                      quantity: 1,
                      properties: { _freeproduct: "true" },
                      sections: this2.cart.getSectionsToRender().map((section) => section.id),
                      sections_url: window.location.pathname,
                    });

                    fetch(`/cart/add.js`, { ...fetchConfig(), ...{ body } })
                      .then((response) => {
                        return response.text();
                      })
                      .then((state) => {
                        var resp = JSON.parse(state);
                        loadData(resp);
                      })
                      .catch(() => {});
                  }
                });
            } else {
              loadData(response);
            }
 
            function loadData(response) {
              if (response.status) {
                this2.handleErrorMessage(response.description);

                const soldOutMessage =
                  this2.submitButton.querySelector(".sold-out-message");
                if (!soldOutMessage) return;
                this2.submitButton.setAttribute("aria-disabled", true);
                this2.submitButton
                  .querySelector("span")
                  .classList.add("hidden");
                soldOutMessage.classList.remove("hidden");
                this2.error = true;
                return;
              } else if (!this2.cart) {
                window.location = window.routes.cart_url;
                return;
              }

              if (!this2.error)
                publish(PUB_SUB_EVENTS.cartUpdate, { source: "product-form" });
              this2.error = false;
              const quickAddModal = this2.closest("quick-add-modal");
              if (quickAddModal) {
                document.body.addEventListener(
                  "modalClosed",
                  () => {
                    setTimeout(() => {
                      this2.cart.renderContents(response);
                    });
                  },
                  { once: true }
                );
                quickAddModal.hide(true);
              } else {
                this2.cart.renderContents(response);
                
              }
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            $(this).find(".productadding").css({ opacity: "1" });
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading-overlay__spinner").classList.add(
              "hidden"
            );
            $(this).find(".plusbtnsvg").removeClass("hidden");
          });
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
